export const OUTPUT_LOG_PROVIDER_AZURE_LOGIC_APP = 'azure_logic_app' as const

export const OUTPUT_LOG_HTTP_METHODS = ['POST', 'PUT', 'PATCH'] as const

export type OutputLogProvider = typeof OUTPUT_LOG_PROVIDER_AZURE_LOGIC_APP

export type OutputLogHttpMethod = (typeof OUTPUT_LOG_HTTP_METHODS)[number]

export interface OutputLogBodyField {
  key: string
  value: string
  secret: boolean
}

export interface IntegrationOutputLog {
  provider: OutputLogProvider
  /** Plaintext in API responses. Encrypted at rest. */
  method: OutputLogHttpMethod | string
  /** Plaintext in API responses. Encrypted at rest. */
  url: string
  bodyFields: OutputLogBodyField[]
}
